import {z} from 'zod';
import {epochTimestamp} from '../_other/epochTimestamp';
import {journalSessionDbSchema} from './journalSessionDbSchema';

export const journalSessionSchema = journalSessionDbSchema.extend({
  id: z.string(),
  createdAt: epochTimestamp,
  updatedAt: epochTimestamp,
});

export interface JournalSession extends z.infer<typeof journalSessionSchema> {}
